import React from 'react';
import { classIf } from '../utils/classIf';

export default function Bonus(props) {
    const data = props.data;
    const total = data.nextBonusThreshold;
    const selected = total - data.eventLeftToGetBonus;
    const percentage = data.reachingPercentage;

    let progressBars = [];
    for (let i = 0; i < total; i++) {
        progressBars.push(
            <div key={i} className={"cart__progress__bar" + classIf(i < selected, 'cart__progress__bar--active')}></div>
        );
    }

    return (
        <div className="cartEvent cartEvent--bonus">
            <div className="cartEvent__header">
                <div className="cartEvent__title">
                    <div className="cartEvent__title__icon cartEvent__title"></div>
                    {props.desc}
                </div>
                <div className="cartEvent__header__controls">
                <div className="cartEvent__header__control cartEvent__header__control--info"></div>
                </div>
            </div>
            <div className="cartEvent__body">
                <div className="cartEvent__body__content">
                    <div className="cartEvent__body__contentText">
                        {data.bonusAdvise}
                    </div>
                    <div className="cart__progress__container">
                        <div className="cart__progress__barsContainer">
                            {progressBars}
                        </div>
                        <div className="cart__progress__textValue">{percentage}%</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
